import React, {useState, useEffect, useRef} from "react";
import BdosViewer from "./bdos_viewer";
import PdosViewer from "./pdos_viewer";
import EleTransportViewer from  "./EleTransportViewer";
import axios from "axios";
const MaterialProperties = ({ materialId }) => {
  const [materialBasic, setMaterialBasic] = useState(null);
  const [optData, setOptData] = useState(null);
  const [scfData, setScfData] = useState(null);
  const [elasticDataJson, setElasticDataJson] = useState(null);
  const [elasticDataText, setElasticDataText] = useState(null);
  const [bandData, setBandData] = useState(null);
  const [bdosUrl, setBdosUrl] = useState(null);  // 添加 BDOS URL 状态
  const [EleData, setEleData] = useState(null);
  const [PhonThermalData, setPhonThermalData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoints = [
          { key: "materialBasic", url: `/api/material_basicprop/${materialId}`, isText: false },
          { key: "optData", url: `/api/opt/${materialId}`, isText: true },
          { key: "scfData", url: `/api/scf/${materialId}`, isText: true },
          { key: "elasticDataJson", url: `/api/elastic/${materialId}`, isText: true },
          { key: "elasticDataText", url: `/api/ElasticProp/${materialId}`, isText: false },
          { key: "bandData", url: `/api/band/${materialId}`, isText: false },
          { key: "PhonThermalData", url: `/api/phon_thermal/${materialId}`, isText: false },
          { key: "EleTransportData", url: `/api/ele/${materialId}`, isText: false },
        ];

        // 🌟 2. 统一换成 axios.get()
        const responses = await Promise.all(
          endpoints.map(item =>
            // axios 会自动拼接 baseURL，自动加 Token，且 res.data 自动解析好数据
            axios.get(item.url).then(res => res.data)
          )
        );
        setMaterialBasic(responses[0]);
        setOptData(responses[1]);
        setScfData(responses[2]);
        setElasticDataJson(responses[3]);
        setElasticDataText(responses[4]);
        setBandData(responses[5]);
        setPhonThermalData(responses[6]);
        setEleData(responses[7]);

        // 获取 BDOS URL
        // http://114.55.7.30/api/get_bdos_url/671e1961ab159a6f6ac9fddf

        // const bdosResponse = await fetch(`http://114.55.7.30/api/get_bdos_url/${materialId}`);
        // if (!bdosResponse.ok) {
        //   throw new Error("Failed to fetch BDOS URL");
        // }
        // const bdosData = await bdosResponse.json();
        // 确保返回的属性名称和状态变量一致
        // if (bdosData && bdosData.bdosUrl) {
        //   setBdosUrl(bdosData.bdosUrl);
        // } else {
        //   console.warn("BDOS URL not found in response.");
        // }
      }
      catch (err) {
        setError("Error loading material data.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [materialId]);

  if (loading) return <p>Loading material data...</p>;
  if (error) return <p>Error: {error}</p>;

  // 渲染 JSON 数据的表格
  const renderTable = (data, title) => (
    <div>
      <h3>{title}</h3>
      <table className="styled-table">
        <tbody>
          {Object.entries(data).map(([key, value]) => (
            <tr key={key}>
              <td className="table-key">{key}</td>
              <td className="table-value">{JSON.stringify(value, null, 2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  // 处理 optData、scfData 的换行和标题加粗
  const formatPlainText = (text) => {
    return text.split("\n").map((line, index) => {
      // 识别 INCAR, KPOINTS, CONTCAR 标题并加粗
      if (line.startsWith("INCAR") || line.startsWith("KPOINTS") || line.startsWith("CONTCAR")
          || line.startsWith("ELASTIC_TENSOR")|| line.startsWith("STIFFNESS_TENSOR")
          || line.startsWith("COMPLIANCE_TENSOR")) {
        return <strong key={index} style={{ color: "blue" }}>{line}</strong>;
      }
      return <div key={index}>{line}</div>;
    });
  };

  // 渲染带格式的纯文本
  const renderFormattedPlainText = (text, title) => (
    <div>
      <h3>{title}</h3>
      <pre className="page-styled-pre">{formatPlainText(text)}</pre>
    </div>
  );

  return (
    <div className="container">
      <h2>Material Properties</h2>
      {materialBasic && renderTable(materialBasic, "Basic Properties")}
      {optData && renderFormattedPlainText(optData, "Opt Data")}
      {scfData && renderFormattedPlainText(scfData, "SCF Data")}

      {(elasticDataJson || elasticDataText) && (
        <div>
          <h3>Elastic Data</h3>
          {elasticDataJson && renderFormattedPlainText(elasticDataJson)}
          {elasticDataText && renderTable(elasticDataText)}
        </div>
      )}

      {bandData && renderTable(bandData, "Band Data")}
      <BdosViewer materialId={materialId} />
      {/*{PhonThermalData && renderTable(PhonThermalData, "PhonThermal Data")}*/}
      <div>
        <h3>{"PhonThermal Data"}</h3>
        <PdosViewer materialId={materialId} />
        <table>
          <thead>
            <tr>
              <th>Temperature</th>
              <th>Free Energy</th>
              <th>Entropy</th>
              <th>Heat Capacity</th>
            </tr>
          </thead>
          <tbody>
            {PhonThermalData.temperatures.map((temp, index) => (
              <tr key={index}>
                <td>{temp}</td>
                <td>{PhonThermalData.free_energy[index]}</td>
                <td>{PhonThermalData.entropy[index]}</td>
                <td>{PhonThermalData.heat_capacity[index]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <EleTransportViewer materialId={materialId} />
            {/* 在页面最后添加 BDOS 交互 HTML */}
      {/*{bdosUrl ? (*/}
      {/*  <div>*/}
      {/*    <h3>BDOS Interactive Plot</h3>*/}
      {/*    <iframe*/}
      {/*      src={bdosUrl}*/}
      {/*      width="100%"*/}
      {/*      height="600px"*/}
      {/*      style={{ border: "none" }}*/}
      {/*    ></iframe>*/}
      {/*  </div>*/}
      {/*) : (*/}
      {/*  <p>BDOS plot not available.</p>*/}
      {/*)}*/}
    </div>
  );
};

export default MaterialProperties;
